import { render, staticRenderFns } from "./PlannedLevelSpells.vue?vue&type=template&id=6f528f61&scoped=true&"
import script from "./PlannedLevelSpells.vue?vue&type=script&lang=js&"
export * from "./PlannedLevelSpells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f528f61",
  null
  
)

export default component.exports